export enum StudentGroupStudentListTableColumns {
  SELECT = 'Select',
  NAME= 'Name',
  STUDENT_ID = "Student ID",
  GRADE = "Grade",
  ACTION = "Action"
}
